/**
 * Vincent B651 (Eric 2026-08-05 SPEC STRICK PROD) — Helper pour appels
 * `fetch()` authentifiés qui ajoute automatiquement le header CSRF.
 *
 * Contexte : axios a un interceptor global qui lit le cookie `XSRF-TOKEN`
 * et l'injecte comme header `X-XSRF-TOKEN` sur tous les POST/PUT/DELETE.
 * Mais `fetch()` n'a pas ce mécanisme → tout POST fait via fetch sans
 * ce header explicite est rejeté par le backend avec HTTP 403 « CSRF
 * token verification failed ».
 *
 * Ce helper doit être utilisé partout où on a besoin de `fetch()` (SSE
 * streaming, uploads, etc. — cas où axios n'est pas adapté).
 *
 * @param {string} url URL de la requête
 * @param {RequestInit} options Options fetch standard
 * @returns {Promise<Response>}
 */
export function csrfFetch(url, options = {}) {
  const csrfToken = document.cookie
    .split("; ")
    .find((c) => c.startsWith("XSRF-TOKEN="))
    ?.split("=")[1] || "";
  const headers = { ...(options.headers || {}) };
  // On n'ajoute le header CSRF que pour les méthodes mutantes (le middleware
  // backend n'exige pas de CSRF sur GET/HEAD/OPTIONS).
  const method = (options.method || "GET").toUpperCase();
  if (csrfToken && !["GET", "HEAD", "OPTIONS"].includes(method)) {
    headers["X-XSRF-TOKEN"] = csrfToken;
  }
  return fetch(url, {
    ...options,
    headers,
    credentials: options.credentials || "include",
  });
}
